import { of as observableOf, Observable } from 'rxjs'
import { Component, Input } from '@angular/core'
import { EntityGroupODataService, IEntityGroup } from '@exchange/domain/.'
import { UtilService } from '@exchange/services/.'

@Component({
  selector: 'app-entity-group-edit-general',
  templateUrl: './entity-group-edit-general.component.html',
  standalone: false
})
export class EntityGroupEditGeneralComponent {
  @Input() model: IEntityGroup = null

  constructor(
    private odata: EntityGroupODataService,
    public util: UtilService
  ) {}

  save(): Observable<any> {
    const errors = []

    if (!this.model.Name) {
      errors.push('Name is required.')
    }

    if (!errors.length) {
      const model = {
        Id: +this.model.Id || undefined,
        Name: this.model.Name
        // TODO: Change this to the new Fee Schdedule Array
        // FeeScheduleId: this.model.FeeScheduleId
      }

      return model.Id
        ? this.odata.put(model as IEntityGroup, model.Id).exec()
        : this.odata.post(model as IEntityGroup).exec()
    }

    return observableOf(errors)
  }
}
